// Owner: task-platform. The screen loads with the route (rich text, playbooks and field editors stay out
// of the app's first paint, plan §10.2); the URL is validated from the light `task-type-tabs` module.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { TaskTypes } from '../../../features/tasks/TaskTypes';
import { TASK_TYPE_TABS } from '../../../features/tasks/task-type-tabs';

const Search = z.object({
  type: z.string().max(63).optional().catch(undefined),
  tab: z.enum(TASK_TYPE_TABS).optional().catch(undefined),
});

export const Route = createFileRoute('/_settings/settings/task-types')({
  validateSearch: Search,
  component: TaskTypesRoute,
});

function TaskTypesRoute() {
  const { type, tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <TaskTypes
      {...(type ? { selected: type } : {})}
      {...(tab ? { tab } : {})}
      onSelect={(next, nextTab) =>
        void navigate({
          search: {
            ...(next ? { type: next } : {}),
            ...(nextTab && nextTab !== 'general' ? { tab: nextTab } : {}),
          },
          replace: true,
        })
      }
    />
  );
}
